import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_ENDPOINTS } from '../constants/api.constant';
import { ApiResponse, User, UserMenuPrivilege } from '../models/api-response.model';

export interface UserPayload {
  name: string;
  lastname: string;
  user_category: string;
  email: string;
  mobile: string | null;
  profile_image: string | null;
  role_id: number;
  account_active: boolean;
}

export interface UserUpdatePayload {
  name: string;
  lastname: string;
  user_category: string;
  email: string;
  mobile: string | null;
  profile_image: string | null;
  role_id: number;
  account_active: boolean;
}

export interface UserMenuPrivilegePayload {
  menu_id: number;
  can_read: boolean;
  can_write: boolean;
}

@Injectable({ providedIn: 'root' })
export class UserManagementService {
  private readonly http = inject(HttpClient);

  list(): Observable<ApiResponse<User[]>> {
    return this.http.get<ApiResponse<User[]>>(API_ENDPOINTS.users);
  }

  create(payload: UserPayload): Observable<ApiResponse<User>> {
    return this.http.post<ApiResponse<User>>(API_ENDPOINTS.users, payload);
  }

  update(userId: number, payload: UserUpdatePayload): Observable<ApiResponse<User>> {
    return this.http.put<ApiResponse<User>>(`${API_ENDPOINTS.users}/${userId}`, payload);
  }

  activate(userId: number): Observable<ApiResponse<User>> {
    return this.http.patch<ApiResponse<User>>(`${API_ENDPOINTS.users}/${userId}/activate`, {});
  }

  deactivate(userId: number): Observable<ApiResponse<User>> {
    return this.http.patch<ApiResponse<User>>(`${API_ENDPOINTS.users}/${userId}/deactivate`, {});
  }

  resetPassword(userId: number): Observable<ApiResponse<User>> {
    return this.http.patch<ApiResponse<User>>(`${API_ENDPOINTS.users}/${userId}/reset-password`, {});
  }

  delete(userId: number): Observable<ApiResponse<''>> {
    return this.http.delete<ApiResponse<''>>(`${API_ENDPOINTS.users}/${userId}`);
  }

  getMenuPrivileges(userId: number): Observable<ApiResponse<UserMenuPrivilege[]>> {
    return this.http.get<ApiResponse<UserMenuPrivilege[]>>(`${API_ENDPOINTS.users}/${userId}/menu-privileges`);
  }

  saveMenuPrivileges(userId: number, privileges: UserMenuPrivilegePayload[]): Observable<ApiResponse<UserMenuPrivilege[]>> {
    return this.http.put<ApiResponse<UserMenuPrivilege[]>>(`${API_ENDPOINTS.users}/${userId}/menu-privileges`, { privileges });
  }
}
